export default __webpack_public_path__ + "static/media/vergne13-14.a46e0b4c.png";